import { StoreModelType } from './types';

const storeModel: StoreModelType = {};

export function registerModel<T>(models: any): T {
    Object.assign(storeModel, models);
    return storeModel as T;
}

export const getModel = <T, S = any>(modelName: keyof S): T => {
    return (storeModel as S)[modelName] as T;
};
